import { request } from 'network/queue';
import { DocumentNode } from 'graphql';

/* eslint-disable import/prefer-default-export */
export const fetchAllPage = async (getPageInfo: any, query: DocumentNode, config: any): Promise<any[]> => {
  const { queueConfig, ...variables } = config;
  const result = await request({ query, variables }, queueConfig);
  const pageInfo = getPageInfo(result);
  if (pageInfo.hasNextPage) {
    return fetchAllPage(getPageInfo, query, { ...config, cursor: pageInfo.endCursor })
      .catch(() => [])
      .then((pages) => [result, ...pages]);
  }
  return [result];
};
